import * as Actions from 'reducks/shopSubscription/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const ShopSubscriptionReducer = (state = initialState.shopSubscription, action: any) => {
  switch (action.type) {
    case Actions.FETCH_SHOP_SUBSCRIPTIONS:
      return {
        ...state,
        shop_subscriptions: [...action.payload.shop_subscriptions],
        store_refs: [...action.payload.store_refs],
      }
    case Actions.INIT_SHOP_SUBSCRIPTIONS:
      return {
        ...initialState.shopSubscription,
      }
    case Actions.RETRIEVE_INVOICES:
      return {
        ...state,
        invoices: [...action.payload],
      }
    case Actions.RETRIEVE_SUBSCRIPTIONS:
      return {
        ...state,
        subscriptions: [...action.payload.subscriptions],
        subscription_schedules: [...action.payload.subscription_schedules],
      }
    default:
      return state
  }
}
